import { Grid, GridItem, VStack } from '@chakra-ui/react';
import { FORM_LAYOUT } from 'components/form/constants';
import { FormField } from 'components/form/Field';
import { FormSection } from 'components/form/Section';

export const FormSectionRenderer = ({
  title,
  fields,
  formData,
  onChange,
  layout = FORM_LAYOUT.GRID,
  columns = 2,
  customRender,
  customSection,
}) => {
  if (customSection) {
    return customSection({ formData, onChange });
  }

  if (customRender) {
    return <FormSection title={title}>{customRender({ formData, onChange })}</FormSection>;
  }

  const renderField = (field) => {
    if (field?.type === 'custom') {
      return field?.render({ formData, onChange });
    }

    return (
      <GridItem key={field?.name}>
        <FormField
          label={field?.label}
          name={field?.name}
          type={field?.type || 'text'}
          value={formData[field?.name]}
          onChange={field?.onChange || onChange}
          placeholder={field?.placeholder}
          isRequired={field?.isRequired !== false}
          {...field?.props}
        />
      </GridItem>
    );
  };

  return (
    <FormSection title={title}>
      {layout === FORM_LAYOUT.GRID ? (
        <Grid templateColumns={`repeat(${columns}, 1fr)`} gap={4}>
          {fields.map(renderField)}
        </Grid>
      ) : (
        <VStack spacing={4}>{fields.map(renderField)}</VStack>
      )}
    </FormSection>
  );
};
